const apiKey = 'pk_test_20b010126344b538c8840064b05d54c5f65000a9'

interface PaystackProps {
  reference: string
  email: string
  amount: number // in kobo
  metadata?: { [key: string]: any }
}

var myWindow: any = window

export const usePaystack = () => {
  const pay = (
    payload: PaystackProps,
    onPaySuccess?: () => void,
    onClose?: () => void
  ) => {
    if (!payload.reference) {
      // Abort if no reference
      return
    }
    if (myWindow.PaystackPop) {
      let handler = myWindow.PaystackPop.setup({
        key: apiKey, // Replace with your public key
        email: payload.email,
        amount: payload.amount,
        ref: payload.reference,
        callback: onPaySuccess,
        onClose,
        channels: ['card', 'bank', 'bank_transfer'],
      })

      handler.openIframe()
    }
  }
  return { pay }
}
